import React from 'react';
import { useParams } from 'react-router-dom';
import CreateResourceAllocation from './CreateResourceAllocation';

const ViewResourceAllocation = () => {
  const { id } = useParams();
  return <CreateResourceAllocation viewMode={true} allocationId={id} />;
};

export default ViewResourceAllocation;

